import { InjectionToken } from '@angular/core';

/**
 * å½åè¿è¡ç¯å¢çæä¸¾é
 */
export enum BrowserENV {
  iphone = 'iphone',
  iphoneX = 'iphoneX',
  android = 'android',
  default = 'default'
}

/**
 * @whatItDoes ç»ç»ä»¶ãæä»¤ææå¡æ³¨å¥å½åè¿è¡ç¯å¢ç token
 * ä¸è¬ç±æ¡æ¶èªå¨æ£æµï¼ä½ å¯ä»¥å¨ç»ä»¶æ³¨å¥ï¼å¹¶æ ¹æ®ä¸åçç¯å¢ï¼ç¼ååç»­é»è¾
 *
 * @howToUse
 * ```typescript
 * import { Inject } from '@angular/core';
 * import { UI_BROWSER_ENV, BrowserENV } from '@cloudbae-frontend/ui-mobile';
 *
 * @Component({
 *   templateUrl: './demo.html'
 * })
 * export class DemoComponent {
 *   constructor(@Inject(UI_BROWSER_ENV) private env: BrowserENV) {
 *     console.log(env); // å½åç¯å¢
 *   }
 * }
 *
 * ```
 */
export const UI_BROWSER_ENV = new InjectionToken<BrowserENV>('UI_BROWSER_ENV');
